export default {
      id: "ic_virtual_bet-usage",
      viewBox: "0 0 30 23",
      url: "/" + "images/icons.3.109.2.svg#ic_virtual_bet-usage",
      toString: function () {
        return this.url;
      }
    }